import { render, staticRenderFns } from "./BaseDateInput.vue?vue&type=template&id=485475d0&scoped=true&"
import script from "./BaseDateInput.vue?vue&type=script&lang=ts&"
export * from "./BaseDateInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDateInput.vue?vue&type=style&index=0&id=485475d0&lang=scss&scoped=true&"
import style1 from "./BaseDateInput.vue?vue&type=style&index=1&id=485475d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485475d0",
  null
  
)

export default component.exports